// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2qhUb","boxTitle":"Qualiphy_boxTitle__1UTS0","box":"Qualiphy_box__2FvUN","toggleWrap":"Qualiphy_toggleWrap__2C1pH"};